export default __webpack_public_path__ + "static/media/Courier-Man.32dba79a.png";